export enum StorageKey
{
  TOKEN = 'Token',
  USER = 'User',
  ROLES = 'Roles',
}
